import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "../Common";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { format } from "date-fns";
import { getType } from "../reducer/reducer";

import { fetchInfoDataSP } from "../service/service";

class SiteInfoSP extends Component {
  fetch() {
    const { fetchInfoDataSP, sitesUC } = this.props;
    fetchInfoDataSP(sitesUC);
  }

  render() {
    const { builders, suppliers, siteDetail } = this.props;

    return (
      <Grid className="pd-15">
        <Grid container>
          <Grid item md={12}>
            <Typography
              variant="subtitle1"
              className="font-family mb-15 text-bold section-title"
            >
              詳細情報
            </Typography>

            <Typography variant="subtitle1" className="font-family mb-15 text-over-wrap">
              <Typography
                variant="subtitle2"
                component="span"
                className="field-name-info font-family"
              >
                現場名
              </Typography>
              {siteDetail.name}
            </Typography>
            <Typography variant="subtitle1" className="font-family mb-15">
              <Typography
                variant="subtitle2"
                component="span"
                className="field-name-info font-family"
              >
                現場監督
              </Typography>
              {siteDetail.employeeNames && siteDetail.employeeNames.join("・")}
            </Typography>

            <Typography variant="subtitle1" className="font-family mb-15 text-over-wrap">
              <Typography
                variant="subtitle2"
                component="span"
                className="field-name-info font-family"
              >
                住所
              </Typography>
              {siteDetail.address}
            </Typography>
          </Grid>
        </Grid>
        <Grid className="third-tab-table mt-25">
          <Grid className="mb-25">
            <Typography
              variant="subtitle1"
              className="font-family mb-15 text-bold section-title"
            >
              担当者情報
            </Typography>
            <TableContainer>
              <Table size="small" aria-label="table" className="sites-table">
                <TableHead className="table-head">
                  <TableRow>
                    <TableCell className="white-text head-30">
                      担当者名
                    </TableCell>
                    <TableCell className="white-text head-30">役割</TableCell>
                    <TableCell className="white-text head-30">
                      現場配属日
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-body">
                  {builders &&
                    builders.map(builder => (
                      <TableRow key={builder.uniqueCode}>
                        <TableCell className="width-30">
                          {builder.name}
                        </TableCell>
                        <TableCell className="width-30">
                          {builder.jobName}
                        </TableCell>
                        <TableCell className="width-40">
                          {builder.assignDate &&
                            format(
                              new Date(builder.assignDate),
                              "yyyy年M月d日"
                            )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid className="mb-25">
            <Typography
              variant="subtitle1"
              className="font-family mb-15 text-bold section-title"
            >
              職人情報
            </Typography>
            <TableContainer>
              <Table size="small" aria-label="table" className="sites-table">
                <TableHead className="table-head">
                  <TableRow>
                    <TableCell className="white-text head-30">会社名</TableCell>
                    <TableCell className="white-text head-30">職人名</TableCell>
                    <TableCell className="white-text head-40">
                      個人携帯
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-body">
                  {suppliers &&
                    suppliers.map(supplier => (
                      <TableRow key={supplier.uniqueCode}>
                        <TableCell className="width-30">
                          {supplier.supplierName}
                        </TableCell>
                        <TableCell className="width-30">
                          <Grid container alignItems="center">
                            {supplier.name}
                            {supplier.job === 1 ? (
                              <Typography variant="caption" className="tag">
                                {supplier.jobName}
                              </Typography>
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </TableCell>
                        <TableCell className="width-40">
                          <a href={`tel:${supplier.phone}`} className="phone">
                            {supplier.phone}
                          </a>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  builders: state.rootSitesReducer.siteInfoReducer.siteBuilderSp,
  suppliers: state.rootSitesReducer.siteInfoReducer.siteSupplierSp,
  siteDetail: state.rootSitesReducer.siteInfoReducer.siteDetail,
  type: getType(state.rootSitesReducer.sitesReducer.type)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchInfoDataSP
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SiteInfoSP));
